export type FilterFor = 'vendor' | 'model' | 'firmwareVersion';

export interface ExpectedConfiguration {
  key: string;
  expectedValue: string;
  filters: ExpectedConfigurationFilter[];
}

export interface ExpectedConfigurationFilter {
  for: FilterFor;
  values: string[];
}

export function findExpectedConfiguration(key: string, { vendor, model, firmwareVersion }: { vendor: string, model: string, firmwareVersion: string }): ExpectedConfiguration | undefined {
  return EXPECTED_CONFIGURATIONS.find(expectedConfig => expectedConfig.key === key && expectedConfig.filters.every(filter => {
    if (filter.for === 'vendor') {
      return filter.values.includes(vendor);
    }
    if (filter.for === 'model') {
      return filter.values.includes(model);
    }
    if (filter.for === 'firmwareVersion') {
      return filter.values.includes(firmwareVersion);
    }
    return false;
  }));
}

export const EXPECTED_CONFIGURATIONS: ExpectedConfiguration[] = [
    {
      key: 'AllowOfflineTxForUnknownId',
      expectedValue: 'false',
      filters: [
          { for: 'vendor', values: ['Schneider Electric'] },
          { for: 'model', values: ['EVlink Smart Wallbox', 'EVlink Pro AC'] }
      ]
    },
    {
      key: 'PlugNumberingMode',
      expectedValue: '0',
      filters: [
          { for: 'vendor', values: ['Schneider Electric'] },
          { for: 'model', values: ['EVlink Pro AC'] }
      ]
    }
];
